import React from "react"
import { storyblokEditable } from "gatsby-source-storyblok"
import { useStaticQuery, graphql } from "gatsby"
import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper/modules"
import AfterContent from "../parts/after_content/after_content.js"
import BeforeContent from "../parts/before_content/before_content.js"
import Background from "../parts/background/background.js"
import TeamMember from "../parts/team_member/team_member.js"

const TeamMembersQuery = ({ blok }) => {
  const { allStoryblokEntry } = useStaticQuery(
    graphql`
      query {
        allStoryblokEntry(
          sort: { name: ASC }
          filter: { field_component: { eq: "team_members" } }
        ) {
          nodes {
            name
            uuid
            content
          }
        }
      }
    `
  )

  const members = allStoryblokEntry?.nodes
    ?.map(node => ({
      ...node,
      content: JSON.parse(node.content),
    }))
    .filter(node => node.content.team_member_category === blok.category_to_show)

  return (
    <section
      {...storyblokEditable(blok)}
      key={blok._uid}
      className={"team_members_query content_block" + ((blok.collapse_top_padding) ? ' collapse-top' : '') + ((blok.collapse_bottom_padding) ? ' collapse-bottom' : '')}
    >
      <Background blok={blok.background_settings} />
      <div className="inner">
        <BeforeContent blok={blok.before_content} />

        <h2 className="h1 outline gs_reveal">{blok.category_to_show}</h2>

        <div className="slider-wrapper">
          <Swiper
            spaceBetween={60}
            slidesPerView="auto"
            navigation={true}
            modules={[Navigation]}
          >
            {members.map(member => (
              <SwiperSlide key={member.uuid}>
                <TeamMember blok={member} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>

        <AfterContent blok={blok.after_content} />
      </div>
    </section>
  )
}

export default TeamMembersQuery
